// Role-based access control helpers (frontend mirror of backend rules)
export const ROLE_LABELS = {
  admin: "Administrator",
  planner: "Production Planner",
  operator: "Operator / Viewer",
};

export const ROLE_COLORS = {
  admin: "bg-blue-600 text-white",
  planner: "bg-sky-500 text-white",
  operator: "bg-slate-500 text-white",
};

export const can = {
  manageOrders: (role) => role === "admin" || role === "planner",
  manageMachines: (role) => role === "admin",
  toggleMachineStatus: (role) => role === "admin" || role === "planner",
  manageUsers: (role) => role === "admin",
  viewUsers: (role) => role === "admin",
};

export const PERMISSION_MATRIX = [
  { feature: "View Dashboard & Schedule", admin: true, planner: true, operator: true },
  { feature: "Create / Edit / Delete Orders", admin: true, planner: true, operator: false },
  { feature: "Reschedule (drag) Orders", admin: true, planner: true, operator: false },
  { feature: "Assign Lines & Resources", admin: true, planner: true, operator: false },
  { feature: "Toggle Machine Status", admin: true, planner: true, operator: false },
  { feature: "Configure Machines", admin: true, planner: false, operator: false },
  { feature: "Assign Operators to Lines", admin: true, planner: false, operator: false },
  { feature: "Import / Export BOM & Catalogs", admin: true, planner: false, operator: false },
  { feature: "Manage User Accounts", admin: true, planner: false, operator: false },
  { feature: "View User Accounts", admin: true, planner: false, operator: false },
];
